import React, { Component } from 'react';
import GetListaItems from './getListaItems';
import GetStepBuy from './getStepBuy';
import GetContacto from './getContacto';

import '../css/getListSucursales.css';
import 'whatwg-fetch';
class getListSucursales extends Component {
  constructor(){
    super();
    this.state = {
        modulo_modal : '',
        sw_validar_delivery:0,
        msg_loading :false,
        lista_sucursales : [],
        id_sucursal : 0,
        title:'',
        costo_delivery:'',
        puntuacion:'',
        tiempo:'',
        lista_items : [],
        items_cantidad: [],
        items_observaciones: [],
        total_items : 0,
        total_precio : 0,
        total_final :0,
        telefono:'',
        leyenda_contacto:'',
        lista_items_adicional:[],
        kilometro:'',
        sms:''
    }
  }
  props_set_data_items =(lista_items)=>{
    this.setState({
      lista_items
    }, ()=>{
      //this.get_loading(false)
    })
  }

  props_set_delete_preferencias=(index_inicial)=>{
      let lista_items_adicional = this.state.lista_items_adicional
      let lista_items_adicional_temp =[]
      lista_items_adicional.forEach((cp,index) => {
        if(Number(index_inicial)!==Number(index)){
          lista_items_adicional_temp=[
            ...lista_items_adicional_temp,{
              'complemento_final': cp.complemento_final,
              'id_producto_combo': cp.id_producto_combo,
              'precio_adicional': cp.precio_adicional,
              'sw_iva': cp.sw_iva,
              'precio_inicial': cp.precio_inicial
            }
          ]
        }
      })
      this.setState({
        lista_items_adicional : lista_items_adicional_temp
      },()=>{
        this.total_pedido()
      })
  }
  props_set_preferencias=(complemento_final,id_producto_combo,precio_adicional,id_index,sw_iva,precio_inicial)=>{
    let lista_items_adicional = this.state.lista_items_adicional
    let lista_items_adicional_temp =[]
    lista_items_adicional.forEach((cp,index) => {
      if(Number(id_index)!==Number(index)){
        lista_items_adicional_temp=[
          ...lista_items_adicional_temp,{
            'complemento_final': cp.complemento_final,
            'id_producto_combo': cp.id_producto_combo,
            'precio_adicional': cp.precio_adicional,
            'sw_iva': cp.sw_iva,
            'precio_inicial': cp.precio_inicial
          }
        ]
      }
    })


    lista_items_adicional=[
      ...lista_items_adicional_temp,{
        complemento_final,id_producto_combo,precio_adicional,sw_iva,precio_inicial
      }
    ]
    this.setState({
      lista_items_adicional
    },()=>{
      this.total_pedido()
    })
  }

  props_set_cantidad =(items_cantidad)=>{
    this.setState(
      {items_cantidad}, ()=>{this.total_pedido()}
    );
  }
  props_set_observacion =(items_observaciones)=>{
    this.setState(
      {items_observaciones}
    );
  }
  total_pedido =()=>{
     const roundTo = require('round-to');
     const lista_items = this.state.lista_items
     const lista_items_adicional = this.state.lista_items_adicional
     const items_cantidad = this.state.items_cantidad
     let costo_delivery = this.state.costo_delivery
     let servicio10 = 0
     let total_precio = 0
     let total_items  = 0
     let total_final = 0

     //console.log(lista_items)

     if(lista_items.length !== 0){
       lista_items.forEach(rubro => {
         rubro.Citems.forEach(item => {
           if(isNaN(items_cantidad[item.id])){
             //cantidad_item = cantidad_item + 1;
           }else{
             total_items = total_items + Number(items_cantidad[item.id]);
             total_precio = total_precio +roundTo(Number(item.precio_venta)*Number(items_cantidad[item.id]) ,2)
             if(Number(item.sw_iva)===1){
               servicio10 = servicio10 + roundTo(((Number(item.precio_venta)/1.12)*0.10)*Number(items_cantidad[item.id]),2)
             }else{
               servicio10 = servicio10 + roundTo(Number(item.precio_venta)*0.10*Number(items_cantidad[item.id]),2)
             }
           }
         })
         //
       })
     }

     if(lista_items_adicional.length !== 0){
       lista_items_adicional.forEach(lista_items_adicional => {
             total_items = total_items + 1;
             total_precio = total_precio +roundTo(Number(lista_items_adicional.precio_inicial)+Number(lista_items_adicional.precio_adicional),2)
             if(Number(lista_items_adicional.sw_iva)===1){
               servicio10 = servicio10 + roundTo(((Number(lista_items_adicional.precio_inicial)+Number(lista_items_adicional.precio_adicional))/1.12),2)
             }else{
               servicio10 = servicio10 + roundTo((Number(lista_items_adicional.precio_inicial)+Number(lista_items_adicional.precio_adicional))*0.10,2)
             }
       })
     }
     if(Number(this.props.id_mesa)>0){
       costo_delivery = servicio10
       total_precio=roundTo(total_precio,2);
       total_final=roundTo(total_precio+Number(costo_delivery),2)
       this.setState({
         total_items,total_precio,total_final,costo_delivery
       })
     }else{
       total_precio=roundTo(total_precio,2);
       total_final=roundTo(total_precio+Number(costo_delivery),2)
       this.setState({
         total_items,total_precio,total_final
       })
     }




     //total_pedido=roundTo(total_pedido,2);
  }

  get_go_to =(modulo_modal)=>{
    let lista_items_adicional = this.state.lista_items_adicional
    let sw_validar_delivery = this.state.sw_validar_delivery
    if(modulo_modal===''){
      lista_items_adicional = []
      sw_validar_delivery=0
    }
    if(modulo_modal==='finalizar_pedido'){
      sw_validar_delivery=1
    }
    this.setState({
      modulo_modal,
      lista_items_adicional,
      sw_validar_delivery
    })
  }
  get_items =(id_sucursal,title,costo_delivery,puntuacion,tiempo,kilometro)=>{
    if(Number(id_sucursal)!==0){
      this.setState({
        id_sucursal,
        modulo_modal:'lista_items',
        title,costo_delivery,puntuacion,tiempo,kilometro,
        lista_items:[],items_cantidad: [],total_items:0,total_precio : 0,items_observaciones:[],
        total_final :0
      })
    }
  }
  getInformacionContacto =(telefono,leyenda_contacto,activo,sms)=>{
    this.setState({
      modulo_modal:'contacto',
      telefono,leyenda_contacto,activo,sms
    })
  }
  get_List_Sucursales=()=>{
    const url= this.props.dir_url + "webapp/getListPedido";
    const token =  this.props.token
    const lat = this.props.lat
    const lon = this.props.lon
    const sucursal = this.props.sucursal

    let current_datetime = new Date()
    let horal = ""+current_datetime.getHours()
    let minutos = ""+current_datetime.getMinutes()
    if(horal.length===1) horal = "0" + horal
    if(minutos.length===1) minutos = "0" + minutos
    const hora =  horal + ":" + minutos
    const dia = new Date().getUTCDay()

    console.log(hora+" "+dia)
    //var data = {username: 'example'};
    var obj = { accion:'find', token, lat, lon ,hora ,dia ,sucursal};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){
        this.setState({
          lista_sucursales:data[0].msg
        }, ()=>{
          this.get_loading(false)
        })
        let nom_sucursal = ""

        /*data[0].msg.map((sucursal , index) => {
          if(Number(sucursal.id_sucursales)===Number(this.props.sucursal)){
            nom_sucursal = sucursal.sucursales
          }
        })*/
        data[0].msg.forEach(sucursal => {
          if(Number(sucursal.id_sucursales)===Number(this.props.sucursal)){
            nom_sucursal = sucursal.sucursales
          }
        })


        if(Number(this.props.sucursal)>0){//Number(this.props.id_mesa)!==0&&
          this.get_items(Number(this.props.sucursal),nom_sucursal,0,
            0,0,0)
        }
      }
    })
    .catch(console.log)
    this.get_loading(true)
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }
  get_new_pedido_loading =(msg_loading,modulo_modal)=>{
    this.setState({
      msg_loading,modulo_modal,lista_items_adicional:[]
    })
    //
  }
  render() {
    //let logo
    const sw_validar_delivery = this.state.sw_validar_delivery
    const uuid_imagen=((this.props.uuid_sucursal)+"").trim()
    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_500x200
    const token_image = url_image+file_xxx+separator
    const ext="_500x200.png?alt=media"
    //if(uuid_imagen===''){
      //logo="https://www.grupomn.net/app/img/sinfoto.png"
    //}else{
      //logo=token_image+uuid_imagen+ext
    //}


    const modulo_modal = this.state.modulo_modal
    const lista_sucursales = this.state.lista_sucursales
    let dir_modulo_modal

    if(modulo_modal==='lista_items'){
      dir_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
                        <GetListaItems  id_mesa={this.props.id_mesa}  props_set_delete_preferencias={this.props_set_delete_preferencias} lista_items_adicional={this.state.lista_items_adicional} props_set_preferencias={this.props_set_preferencias} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_250x250={this.props.file_250x250} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}   props_set_data_items={this.props_set_data_items} props_set_observacion={this.props_set_observacion} props_set_cantidad={this.props_set_cantidad} lista_items={this.state.lista_items} items_observaciones={this.state.items_observaciones}  items_cantidad={this.state.items_cantidad} total_items={this.state.total_items} total_precio={this.state.total_precio} token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to} sucursal={this.props.sucursal} id_sucursal={this.state.id_sucursal} title={this.state.title} costo_delivery={this.state.costo_delivery} puntuacion={this.state.puntuacion} tiempo={this.state.tiempo} kilometro={this.state.kilometro} />
                        </div>
    }
    if(modulo_modal==='contacto'){
      dir_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
                        <GetContacto sms={this.state.sms} activo={this.state.activo} telefono={this.state.telefono} leyenda_contacto={this.state.leyenda_contacto} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   uuid_sucursal={this.props.uuid_sucursal}
                         token={this.props.token} dir_url={this.props.dir_url} get_go_to={this.get_go_to} id_sucursal={this.state.id_sucursal}  />
                        </div>
    }
    if(modulo_modal==='finalizar_pedido'){
      if(sw_validar_delivery===1){
        this.getValueDelivery()
      }
      dir_modulo_modal = <div id="loader_msg_sucursal" className="loader_msg_sucursal is-active" data-text="">
                        <GetStepBuy sucursal={this.props.sucursal} id_mesa={this.props.id_mesa} props_set_delete_preferencias={this.props_set_delete_preferencias} lista_items_adicional={this.state.lista_items_adicional} props_set_preferencias={this.props_set_preferencias} separator={this.props.separator} url_image={this.props.url_image}  firebase={this.props.firebase} file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}   get_new_pedido_loading={this.get_new_pedido_loading} get_loading={this.get_loading}
                        id_sucursal={this.state.id_sucursal} token_Client={this.props.token_Client}
                        token={this.props.token} dir_url={this.props.dir_url}  name={this.props.name} lat={this.props.lat} lon={this.props.lon}
                        props_set_cantidad={this.props_set_cantidad} props_set_observacion={this.props_set_observacion} lista_items={this.state.lista_items}
                        items_cantidad={this.state.items_cantidad} items_observaciones={this.state.items_observaciones} total_items={this.state.total_items} kilometro={this.state.kilometro} total_final={this.state.total_final}
                        total_precio={this.state.total_precio} costo_delivery={this.state.costo_delivery} get_go_to={this.get_go_to} />
                        </div>
    }

    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
//
    return (
      <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
        <div className="cssversion_pw100 cssversion_ph100">
          {lista_sucursales.map(sucursal => (
            <div key={sucursal.id_sucursales}
              className={(Number(sucursal.acivo)===1||Number(sucursal.acivo)===-2) ? "cssversion_pw100 cssversion_rainbow":"cssversion_pw100 cssversion_rainbow" }
              style={{
                "backgroundImage": "url(" + ((sucursal.uuid_sucursal_) ? (token_image+sucursal.uuid_sucursal_+ext):(token_image+uuid_imagen+ext)) + ")","margin":"7px 0px 7px 0px",
                "borderRadius": "25px 0px 25px 0px"
              }}
              onClick={ (Number(sucursal.acivo)===1) ?
              () => this.get_items(sucursal.id_sucursales,sucursal.sucursales,sucursal.precio_delivery,
                sucursal.like,sucursal.tiempo_aproximado,sucursal.kilometro):
                (Number(sucursal.acivo)===0||Number(sucursal.acivo)===-1) ?
                () => this.getInformacionContacto(sucursal.telefono,sucursal.leyenda_contacto,sucursal.acivo,sucursal.hora)
                :
                () => this.getInformacionContacto(sucursal.telefono,sucursal.leyenda_contacto,sucursal.acivo,sucursal.kilometro)
              }
              >
              <div className="cssversion_pw100 cssversion_pxh80 cssversion_contentCenter">
                <span className="cssversion_span-title-sucursal">{sucursal.sucursales}</span>
              </div>
              <div className="cssversion_pw100 cssversion_pxh50 cssversion_contentCenter cssversion_colorblanco" style={{"borderRadius": "25px 0px 25px 0px"}}>
                <div className="cssversion_pw30 cssversion_pxh50 cssversion_contentCenter">
                  <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/11140696671582004489-128.png') }  />
                  <span className="span-global" style={{"padding":"5px"}}>{sucursal.precio_delivery}$</span>
                </div>
                <div className="cssversion_pw40 cssversion_pxh50 cssversion_contentCenter">
                  {(Number(sucursal.acivo)===-1)?
                    <span className="span-global" style={{"padding":"5px"}}>{sucursal.hora}</span>
                    :
                    <React.Fragment>
                    <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  />
                    <span className="span-global" style={{"padding":"5px"}}>{sucursal.kilometro+"Km"}</span>
                    </React.Fragment>
                  }
                </div>
                <div className="cssversion_pw30 cssversion_pxh50 cssversion_contentCenter">
                  <span className="span-global" style={{"padding":"5px"}}>{sucursal.tiempo_aproximado}'</span>
                  <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16882276531582004488-128.png') }  />
                </div>
              </div>
            </div>
          )) }
        </div>
        {modal_loading}
        {dir_modulo_modal}
      </div>
    )
  }
  /*<div style={{"position": "fixed","height":"75%"}} className="yoverflow ph100 pw100 grid-container-sucursal">
    <div style={{"width":"97%"}}>
      <div className="grid colorblanco grid-bleed pw100" style={{"margin":"0px","letterSpacing":"0em","wordSpacing":"0em"}}>
        <div className="col-12 col-grid pw100">
          <span className="span-global">Seleccione un Local</span>
        </div>
      </div>
      {lista_sucursales.map(sucursal => (
        <div key={sucursal.id_sucursales}
          className={(Number(sucursal.acivo)===1||Number(sucursal.acivo)===-2) ? "grid grid-bleed pw100":"grid grid-bleed pw100" }
          style={{
            "backgroundImage": "url(" + logo + ")","margin":"7px 0px 7px 0px",
            "borderRadius": "25px","letterSpacing":"0em","wordSpacing":"0em"
          }}
          onClick={ (Number(sucursal.acivo)===1) ?
          () => this.get_items(sucursal.id_sucursales,sucursal.sucursales,sucursal.precio_delivery,
            sucursal.like,sucursal.tiempo_aproximado,sucursal.kilometro):
            (Number(sucursal.acivo)===0||Number(sucursal.acivo)===-1) ?
            () => this.get_items(0)
            :
            () => this.getInformacionContacto(sucursal.telefono,sucursal.leyenda_contacto)
          }
          >
          <div className="col-12 col-grid pxh100 centerContent">
            <span className="span-title-sucursal">{sucursal.sucursales}</span>
          </div>
          <div className="col-2 pxh40 colorblanco">
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/11140696671582004489-128.png') }  />
            <span className="span-global">{sucursal.precio_delivery}$</span>
          </div>
          <div className="col-8 pxh40 colorblanco">
            {(Number(sucursal.acivo)===-1)?
              <span className="span-global">{sucursal.hora}</span>
              :
              <React.Fragment>
              <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15808962761582004492-128.png') }  />
              <span className="span-global">{sucursal.kilometro+"Km"}</span>
              </React.Fragment>
            }
          </div>
          <div className="col-2 pxh40 colorblanco">
            <span className="span-global">{sucursal.tiempo_aproximado}'</span>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/16882276531582004488-128.png') }  />
          </div>
        </div>
      )) }
    {modal_loading}
    {dir_modulo_modal}
    </div>
  </div>*/

  getValueDelivery =()=>{
    const sw_validar_delivery = this.state.sw_validar_delivery
    if(sw_validar_delivery!==1)return
    const url= this.props.dir_url + "webapp/getCostoDelivery";
    const token =  this.props.token
    const lat = this.props.lat
    const lon = this.props.lon
    const id_sucursal = this.state.id_sucursal
    console.log(id_sucursal)
    var obj = { accion:'getcostodelivery', token, lat, lon  ,id_sucursal};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){
        let kilometro_actual = 0
        let costo_delivery =0
        if(data[0].base==="bd_app_5esquinas"){
                kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;

                //kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;
                /*if(kilometro_actual<=5){
                  costo_delivery =2.1
                }else if(kilometro_actual<=5.4) {
                  costo_delivery =2.1
                }else if(kilometro_actual<=6.4){
                  costo_delivery =2.5
                }else if(kilometro_actual<=7.4){
                  costo_delivery =2.85
                }else if(kilometro_actual<=8.4){
                  costo_delivery =3.2
                }else if(kilometro_actual<=9.4){
                  costo_delivery =3.55
                }else if(kilometro_actual<=10.4){
                  costo_delivery =3.90
                }else if(kilometro_actual<=11.4){
                  costo_delivery =4.25
                }else if(kilometro_actual<=12.4){
                  costo_delivery =4.6
                }else if(kilometro_actual<=13.4){
                  costo_delivery =4.95
                }else if(kilometro_actual<=14.4){
                  costo_delivery =5.3
                }else if(kilometro_actual<=15.4){
                  costo_delivery =5.65
                }else if(kilometro_actual<=16.4){
                  costo_delivery =6
                }else if(kilometro_actual<=17.4){
                  costo_delivery =6.35
                }else if(kilometro_actual<=18.4){
                  costo_delivery =6.7
                }else if(kilometro_actual<=19.4){
                  costo_delivery =7.05
                }else if(kilometro_actual<=20.4){
                  costo_delivery =7.4
                }else if(kilometro_actual<=21.4){
                  costo_delivery =7.75
                }else if(kilometro_actual<=22.4){
                  costo_delivery =8.1
                }else if(kilometro_actual<=23.4){
                  costo_delivery =8.45
                }else if(kilometro_actual<=24.4){
                  costo_delivery =8.8
                }else if(kilometro_actual<=25.4){
                  costo_delivery =9.15
                }*/
                if(kilometro_actual<=5){
                    costo_delivery = 2.4
                }else if(kilometro_actual<=6){
                    costo_delivery = 2.9
                }else if(kilometro_actual<=7){
                    costo_delivery = 3.3
                }else if(kilometro_actual<=8){
                    costo_delivery = 3.7
                }else if(kilometro_actual<=9){
                    costo_delivery = 4.1
                }else if(kilometro_actual<=10){
                    costo_delivery = 4.5
                }else if(kilometro_actual<=11){
                    costo_delivery = 4.9
                }else if(kilometro_actual<=12){
                    costo_delivery = 5.3
                }else if(kilometro_actual<=13){
                    costo_delivery = 5.7
                }else if(kilometro_actual<=14){
                    costo_delivery = 6.1
                }else if(kilometro_actual<=15){
                    costo_delivery = 6.5
                }else if(kilometro_actual<=16){
                    costo_delivery = 6.9
                }else if(kilometro_actual<=17){
                    costo_delivery = 7.3
                }else if(kilometro_actual<=18){
                    costo_delivery = 7.7
                }else if(kilometro_actual<=19){
                    costo_delivery = 8.1
                }else if(kilometro_actual<=20){
                    costo_delivery = 8.5
                }else if(kilometro_actual<=21){
                    costo_delivery = 8.9
                }else if(kilometro_actual<=22){
                    costo_delivery = 9.3
                }else if(kilometro_actual<=23){
                    costo_delivery = 9.7
                }else if(kilometro_actual<=24){
                    costo_delivery = 10.1
                }else if(kilometro_actual<=25){
                    costo_delivery = 10.5
                }else if(kilometro_actual<=26){
                    costo_delivery = 10.9
                }else if(kilometro_actual<=27){
                    costo_delivery = 11.3
                }else if(kilometro_actual<=28){
                    costo_delivery = 11.7
                }else if(kilometro_actual<=29){
                    costo_delivery = 12.1
                }else if(kilometro_actual<=30){
                    costo_delivery = 12.5
                }
            }else{
            if(data[0].base==="bd_app_eldt"){
              kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;

              //let costo_delivery =0
              if (kilometro_actual <= 1.64) {
                costo_delivery = 1.65;
              } else if (kilometro_actual <= 5.04) {
                costo_delivery = 2.15;
              } else if (kilometro_actual <= 6.04) {
                costo_delivery = 2.70;
              } else if (kilometro_actual <= 7.04) {
                costo_delivery = 3.25;
              } else if (kilometro_actual <= 8.04) {
                costo_delivery = 3.80;
              } else if (kilometro_actual <= 9.04) {
                costo_delivery = 4.30;
              } else if (kilometro_actual <= 10.04) {
                costo_delivery = 4.80;
              } else if (kilometro_actual <= 11.04) {
                costo_delivery = 5.30;
              } else if (kilometro_actual <= 12.04) {
                costo_delivery = 5.85;
              } else if (kilometro_actual <= 13.04) {
                costo_delivery = 6.35;
              } else if (kilometro_actual <= 14.04) {
                costo_delivery = 6.85;
              } else if (kilometro_actual <= 15.04) {
                costo_delivery = 7.40;
              } else if (kilometro_actual <= 16.04) {
                costo_delivery = 7.90;
              } else if (kilometro_actual <= 17.04) {
                costo_delivery = 8.40;
              } else if (kilometro_actual <= 18.04) {
                costo_delivery = 8.95;
              } else if (kilometro_actual <= 19.04) {
                costo_delivery = 9.45;
              } else if (kilometro_actual <= 20.04) {
                costo_delivery = 10.00;
              } else if (kilometro_actual <= 21.04) {
                costo_delivery = 10.50;
              } else if (kilometro_actual <= 22.04) {
                costo_delivery = 11.00;
              } else if (kilometro_actual <= 23.04) {
                costo_delivery = 11.50;
              } else if (kilometro_actual <= 24.04) {
                costo_delivery = 12.05;
              } else if (kilometro_actual <= 25.04) {
                costo_delivery = 12.55;
              } else if (kilometro_actual <= 26.04) {
                costo_delivery = 13.05;
              } else if (kilometro_actual <= 27.04) {
                costo_delivery = 13.60;
              } else if (kilometro_actual <= 28.04) {
                costo_delivery = 14.10;
              } else if (kilometro_actual <= 29.04) {
                costo_delivery = 14.65;
              } else if (kilometro_actual <= 30.04) {
                costo_delivery = 15.15;
              }
            }else{
              kilometro_actual = Number(data[0].msg.routes[0].legs[0].distance.value)/1000;

              //let costo_delivery =0
              if(kilometro_actual<=1.4){
                costo_delivery =1.8
              }else if(kilometro_actual<=5.4) {
                costo_delivery =2.1
              }else if(kilometro_actual<=6.4){
                costo_delivery =2.5
              }else if(kilometro_actual<=7.4){
                costo_delivery =2.85
              }else if(kilometro_actual<=8.4){
                costo_delivery =3.2
              }else if(kilometro_actual<=9.4){
                costo_delivery =3.55
              }else if(kilometro_actual<=10.4){
                costo_delivery =3.90
              }else if(kilometro_actual<=11.4){
                costo_delivery =4.25
              }else if(kilometro_actual<=12.4){
                costo_delivery =4.6
              }else if(kilometro_actual<=13.4){
                costo_delivery =4.95
              }else if(kilometro_actual<=14.4){
                costo_delivery =5.3
              }else if(kilometro_actual<=15.4){
                costo_delivery =5.65
              }else if(kilometro_actual<=16.4){
                costo_delivery =6
              }else if(kilometro_actual<=17.4){
                costo_delivery =6.35
              }else if(kilometro_actual<=18.4){
                costo_delivery =6.7
              }else if(kilometro_actual<=19.4){
                costo_delivery =7.05
              }else if(kilometro_actual<=20.4){
                costo_delivery =7.4
              }else if(kilometro_actual<=21.4){
                costo_delivery =7.75
              }else if(kilometro_actual<=22.4){
                costo_delivery =8.1
              }else if(kilometro_actual<=23.4){
                costo_delivery =8.45
              }else if(kilometro_actual<=24.4){
                costo_delivery =8.8
              }else if(kilometro_actual<=25.4){
                costo_delivery =9.15
              }
            }
          }

        this.setState({
          sw_validar_delivery:2,
          kilometro:kilometro_actual,
          costo_delivery
        },()=>this.total_pedido())


      }
    })
    .catch(console.log)
  }
  componentDidMount (){
    this.get_List_Sucursales();
  }
}
export default getListSucursales;
